import React, { useState, useEffect, useCallback, useMemo } from 'react';
import KpiService from '../../../services/kpi.service';
import { useTranslation } from 'react-i18next';

const ExternalKpiDataSource = ({ kpiId }) => {
  const { t } = useTranslation();
  const [latestKpiValue, setLatestKpiValue] = useState(null);
  const [isLoadingKpiValue, setIsLoadingKpiValue] = useState(false);

  const fetchLatestKpiValue = useCallback((id) => {
    setIsLoadingKpiValue(true);
    const kpiService = new KpiService();
    kpiService
      .fetchLatestKpiValue(id)
      .then((response) => {
        if (response.data?.value !== undefined) {
          setLatestKpiValue(response.data.value);
        }
        setIsLoadingKpiValue(false);
      })
      .catch((error) => {
        console.error('Error fetching latest KPI value:', error);
        setIsLoadingKpiValue(false);
      });
  }, []);

  useEffect(() => {
    if (!kpiId) {
      return;
    }

    setLatestKpiValue(null);
    fetchLatestKpiValue(kpiId);
  }, [kpiId, fetchLatestKpiValue]);

  const displayValue = useMemo(() => {
    if (isLoadingKpiValue) {
      return t('Loading...');
    }
    return latestKpiValue !== null ? latestKpiValue : '--';
  }, [isLoadingKpiValue, latestKpiValue, t]);

  return (
    <div className="salesforceSelectedValue" title="">
      {`${t('Last Value')}: ${displayValue}`}
    </div>
  );
};

export default React.memo(ExternalKpiDataSource);
